var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignaturesEmptyImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M115.581 30H43.608C41.063 30 39 32.05 39 34.58v90.84c0 2.529 2.063 4.58 4.608 4.58h71.973c2.544 0 4.607-2.051 4.607-4.58V34.58c0-2.53-2.063-4.58-4.607-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6BABF",
    d: "M60.22 42.5h-6.287a2.35 2.35 0 0 0-2.358 2.344 2.35 2.35 0 0 0 2.358 2.343h6.287a2.35 2.35 0 0 0 2.358-2.343A2.35 2.35 0 0 0 60.22 42.5ZM104.234 42.5H83.8a2.35 2.35 0 0 0-2.358 2.344 2.35 2.35 0 0 0 2.358 2.343h20.434a2.351 2.351 0 0 0 2.358-2.343 2.351 2.351 0 0 0-2.358-2.344Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFC2C7",
    d: "M69.652 67.5H53.933a2.35 2.35 0 0 0-2.358 2.343 2.35 2.35 0 0 0 2.358 2.344h15.719a2.351 2.351 0 0 0 2.358-2.344 2.351 2.351 0 0 0-2.358-2.344Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6BABF",
    d: "M104.305 54.561H54.002a2.64 2.64 0 0 0-2.647 2.631v.002a2.64 2.64 0 0 0 2.647 2.63h50.303a2.64 2.64 0 0 0 2.647-2.63v-.002a2.639 2.639 0 0 0-2.647-2.63ZM104.307 77.368H54.002A2.64 2.64 0 0 0 51.355 80v.002a2.64 2.64 0 0 0 2.647 2.63h50.305a2.639 2.639 0 0 0 2.647-2.63v-.002a2.64 2.64 0 0 0-2.647-2.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 26,
    x: 52,
    y: 91,
    fill: "#DBEAFE",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M88 104.66a1.006 1.006 0 0 0-.785.077 1.009 1.009 0 0 0-.485.623c-.21.77-1 3-2.39 3.45.08-.42.22-1 .32-1.33.41-1.58.71-2.71-.23-3.25a1.999 1.999 0 0 0-2.79.42c-.218.288-.402.6-.55.93a7.138 7.138 0 0 1-2.18 2.81c-.35.179-.73.291-1.12.33a2.47 2.47 0 0 1-1-.5 1.489 1.489 0 0 1-.21-.28c5.29-5.08 5.58-9.51 5.52-10.84a3.589 3.589 0 0 0-1.21-2.91 1 1 0 0 0-.84-.19c-2.86.59-4.63 4-5.57 10.83l-.05.25a7.89 7.89 0 0 0-.17 2.19l-.83.73a4.178 4.178 0 0 1-1.31 1 1.25 1.25 0 0 1 .19-.69 1.001 1.001 0 0 0-.31-1.45 1.061 1.061 0 0 0-1.44.27 2.7 2.7 0 0 0 .18 3.48c.34.271.766.409 1.2.39a4.45 4.45 0 0 0 2.88-1.54l.2-.17c.072.1.152.194.24.28a4.229 4.229 0 0 0 2.34 1.15c.894 0 1.77-.25 2.53-.72a8.105 8.105 0 0 0 2.47-2.94c-.42 1.57-.64 2.58-.14 3.27a1.298 1.298 0 0 0 .94.54c2.37.27 4.35-1.6 5.29-5a1 1 0 0 0-.69-1.21Zm-8.13-8.43c.101.388.145.79.13 1.19 0 1-.31 3.91-3.47 7.57.47-3.51 1.47-7.66 3.34-8.76Zm10.07 6.28a1.458 1.458 0 0 1-1.45 1.289 1.458 1.458 0 0 1-1.45-1.289 1.449 1.449 0 1 1 2.9 0ZM104 113.316H56v1h48v-1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 93.188,
    height: 112,
    x: 33,
    y: 30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_930_15151"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_930_15151",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignaturesEmptyImage);
export default __webpack_public_path__ + "static/media/SignaturesEmptyImage.31b176175125b77628b39fe6a924c5f8.svg";
export { ForwardRef as ReactComponent };